import * as AgenciesActions from './agencies';

const Actions = {
  ...AgenciesActions,
};

export default Actions;
